import { create } from 'zustand';

// One menu row as GET /menus/user/:userId returns it. `description` exists in the table
// and reaches the browser, but is empty for almost every row today.
export interface MenuItem {
  id: string;
  name: string;
  code: string;
  icon: string | null;
  path: string | null;
  parent_id: string | null;
  display_order: number;
  is_active: boolean;
  description?: string | null;
}

interface MenuState {
  /** Active rows this person holds, as sent by the server. Not yet narrowed by the web's own hiding rules — use navigation/menuTree for that. */
  items: MenuItem[];
  /** False until the shell's first menu answer (or failure) has arrived. */
  loaded: boolean;
  setMenu: (items: MenuItem[]) => void;
  clearMenu: () => void;
}

// The shell (DashboardLayout) fetches the menu once per sign-in / page load and puts it
// here, so the home screen, the section front pages, the trail and page search all read
// the same copy instead of asking again. NOT persisted: the menu is the access list.
export const useMenuStore = create<MenuState>()((set) => ({
  items: [],
  loaded: false,
  setMenu: (items) => set({ items, loaded: true }),
  clearMenu: () => set({ items: [], loaded: false }),
}));
